<div [ngClass]="{
    'marginBottom': positionRowIdx === 0 && block.bundle !== 'blocco_visore_hero_1',
    'margin': positionRowIdx !== 0
}">
<div *ngIf="block.titolo_generale" class="w-100 hidden-phone container-general-title">
    <app-sample-general-titles [block]="block"></app-sample-general-titles>
</div>
<div>
    <app-container-sample-card [block]="block"></app-container-sample-card>
    <app-sample-carousel *ngIf="goToCarousel()" [block]="block"></app-sample-carousel>
    <ng-container [ngSwitch]="bundle" class="align-items-stretch">
        <div class="me-3">
            <app-sample-date-to-remember *ngSwitchCase="'blocco_date_to_remember'" [block]="block.items" [padding]="true">
            </app-sample-date-to-remember>
            <app-sample-accordion *ngSwitchCase="'blocco_accordion'" [block]="block.items" [title]="block.titolo_generale ? block.titolo_generale : ''"></app-sample-accordion>
            <app-sample-button *ngSwitchCase="'blocco_pulsante'" [block]="block.items" [column]="block.colonne_occupate"
                [padding]="true">
            </app-sample-button>
            <app-sample-tab *ngSwitchCase="'blocco_tab'" [block]="block.items"></app-sample-tab>
            <app-sample-checklist *ngSwitchCase="'blocco_checklist'" [block]="block.items" [title]="block.titolo_generale"
                [subtitle]="block.sottotitolo_generale" [column]="block.colonne_occupate"></app-sample-checklist>
            <app-sample-timeline *ngSwitchCase="'blocco_timeline'" [block]="block.items" [column]="block.colonne_occupate">
            </app-sample-timeline>
            <app-sample-feature *ngSwitchCase="'blocco_feature'" [block]="block.items" [column]="block.colonne_occupate"
                [padding]="true">
            </app-sample-feature>
            <app-sample-alert *ngSwitchCase="'blocco_alert'" [block]="block.items" [column]="block.colonne_occupate"
                [padding]="true">
            </app-sample-alert>
                <app-sample-modal *ngSwitchCase="'blocco_modale'" [block]="block.items"></app-sample-modal>
            <app-sample-paragraph *ngSwitchCase="'blocco_paragrafo_1'" [block]="block.items"
                [column]="block.colonne_occupate" [padding]="true">
            </app-sample-paragraph>
            <app-sample-single-announcement *ngSwitchCase="'blocco_bando'" [block]="block.items"
                [column]="block.colonne_occupate" [padding]="true">
            </app-sample-single-announcement>
            <app-sample-logos *ngSwitchCase="'blocco_logo'" [block]="block.items" [viewCarousel]="block.visualizza_come_carousel?.toLowerCase()"></app-sample-logos>
            <app-sample-card-docenti *ngSwitchCase="'blocco_persona_docente'" [block]="block.items"></app-sample-card-docenti>
        </div>
    </ng-container>
</div>
</div>